import { TRACE_BASE_URL } from "../utils/urls";

const fetchDataTrace = async ({ uri }: any) => {
  const response = await fetch(`${TRACE_BASE_URL}/${uri}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
  const result = await response.json();
  return result;
};

export default fetchDataTrace;
